import React from "react";
import "./index.css";
import Menu from "./Menu";

const MainMenu = () => {
  return (
    <main className="App">
      <Menu />
    </main>
  );
};

export default MainMenu;
